import React from 'react'
import Plot from 'react-plotly.js'
import { Paper, Typography } from '@mui/material'

interface DTCSeverityData {
    severity: string
    count: number
}

interface DTCSeverityChartProps {
    title: string
    data: DTCSeverityData[]
}

export const DTCSeverityChart: React.FC<DTCSeverityChartProps> = ({
    title,
    data,
}) => {
    const colors = {
        Yellow: '#FFA726',
        Green: '#4CAF50',
        Red: '#F44336',
        '(Blank)': '#9E9E9E',
        Gray: '#757575',
    }

    const sortedData = [...data].sort((a, b) => b.count - a.count)

    return (
        <Paper sx={{ p: 2, height: 350 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
                {title}
            </Typography>
            <Plot
                data={[
                    {
                        type: 'bar',
                        orientation: 'h',
                        x: sortedData.map((item) => item.count),
                        y: sortedData.map((item) => item.severity),
                        marker: {
                            color: sortedData.map(
                                (item) =>
                                    colors[
                                        item.severity as keyof typeof colors
                                    ] || '#9E9E9E'
                            ),
                            opacity: 0.8,
                        },
                        text: sortedData.map((item) =>
                            item.count.toLocaleString()
                        ),
                        textposition: 'outside',
                        textfont: {
                            color: 'white',
                            size: 10,
                        },
                        hovertemplate:
                            '<b>%{y}</b><br>Count: %{x}<extra></extra>',
                    },
                ]}
                layout={{
                    height: 280,
                    margin: { t: 10, r: 60, l: 80, b: 30 },
                    paper_bgcolor: '#2d2d2d',
                    plot_bgcolor: '#2d2d2d',
                    font: {
                        color: 'white',
                        family: 'Roboto, sans-serif',
                        size: 10,
                    },
                    xaxis: {
                        gridcolor: '#444444',
                        showgrid: true,
                        zeroline: false,
                        tickfont: { color: 'white', size: 9 },
                        range: [
                            0,
                            Math.max(...sortedData.map((item) => item.count)) *
                                1.2,
                        ],
                    },
                    yaxis: {
                        gridcolor: 'transparent',
                        showgrid: false,
                        zeroline: false,
                        tickfont: { color: 'white', size: 9 },
                        automargin: true,
                    },
                    showlegend: false,
                    bargap: 0.3,
                }}
                config={{
                    displayModeBar: false,
                    responsive: true,
                }}
                style={{ width: '100%', height: '100%' }}
            />
        </Paper>
    )
}
